import {IComponentController, IComponentOptions} from "angular";
import './customer-address.component.scss';

export class CustomerAddressComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./customer-address.component.html'),
        controller: [CustomerAddressComponent],
        bindings: {
            customer: '<'
        }
    };
}